var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2246 2.2002H4.77512C3.35376 2.2002 2.2002 3.35376 2.2002 4.77512V20.2246C2.2002 21.646 3.35376 22.7996 4.77512 22.7996H20.2246C21.646 22.7996 22.7996 21.646 22.7996 20.2246V4.77512C22.7996 3.35376 21.646 2.2002 20.2246 2.2002ZM21.5121 20.2246C21.5121 20.9365 20.9367 21.5121 20.2246 21.5121H4.77512C4.06443 21.5121 3.48765 20.9365 3.48765 20.2246V4.77512C3.48765 4.06443 4.06443 3.48765 4.77512 3.48765H20.2246C20.9365 3.48765 21.5121 4.06443 21.5121 4.77512V20.2246Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 17.3232C10.1634 17.3232 10.0372 17.2956 9.92104 17.2422C9.80493 17.1888 9.70174 17.1109 9.61857 17.0138L5.00917 11.636C4.93346 11.5477 4.87589 11.4453 4.83974 11.3347C4.8036 11.2242 4.78959 11.1075 4.79851 10.9915C4.81653 10.7573 4.92687 10.5398 5.10525 10.3869C5.28364 10.234 5.51546 10.1582 5.74972 10.1762C5.98398 10.1942 6.20148 10.3046 6.35439 10.483L10.3824 15.1823L18.736 7.89519C18.9135 7.74443 19.1433 7.66966 19.3756 7.68704C19.6079 7.70443 19.8239 7.81259 19.9771 7.98811C20.1302 8.16363 20.208 8.39238 20.1938 8.62487C20.1795 8.85735 20.0742 9.07487 19.9008 9.23033L10.8737 17.1049C10.7123 17.2456 10.5054 17.3231 10.2913 17.3232Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/Selected.b0cb28400e4bd371dc7eec146759227e.svg";
export { ForwardRef as ReactComponent };